/// <amd-module name="VC/Markdown/Plugins/PathUtilities/TfvcVersionControlPathUtility" />

/*
 * This file was ported from the legacy webplatform
 * Logic that is not needed for markdown token transformation was not ported over.
 * Logic has only been changed where necessary to interact in the modern web platform.
 * There is no intention to change any factorings or style otherwise.
 */
import * as VersionControlPathUrl from "VC/Markdown/Plugins/PathUtilities/VersionControlPathUrl";
import * as VersionControlPath from "VC/Markdown/Plugins/PathUtilities/VersionControlPath";
import { TfvcVersionControlPath } from "VC/Markdown/Plugins/PathUtilities/TfvcVersionControlPath";

export class TfvcVersionControlPathUtility {

    public static combine(path1?: string, path2?: string): string {

        if (!path1) {
            return path2 !== undefined ? path2 : "";
        }

        if (!path2) {
            return path1 !== undefined ? path1 : "";
        }

        let tfvcPath1: TfvcVersionControlPath = new TfvcVersionControlPath(path1);
        if (!tfvcPath1.getIsValid()) {
            throw new Error(path1 + " is not a valid TfVC path.");
        }

        let root: string = tfvcPath1.getProjectRoot();

        let basePath = VersionControlPathUrl.resolveRelativePath(tfvcPath1.getRelativePath(), "/");
        let path = path2;

        let tfvcPath2: TfvcVersionControlPath = new TfvcVersionControlPath(path2);
        // if path is root, return it as-is
        if (tfvcPath2.getIsValid()) {
            if (!tfvcPath2.getRelativePath()) {
                return path2;
            }
            else {
                root = tfvcPath2.getProjectRoot();
                basePath = "/";
                path = tfvcPath2.getRelativePath();
            }
        }
        else if (path2.charAt(0) === '/') {
            basePath = "/";
            path = path2.substr(1);
        }

        let directory: string = VersionControlPath.getDirectory(basePath);
        path = VersionControlPathUrl.resolveRelativePath(path, directory);
        let fullPath = root
        if (path.charAt(0) === '/') {
            fullPath += path;
        }
        else {
            fullPath += "/" + path;
        }
        return fullPath;
    }
}
